import React from 'react';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
import { View } from '../../View';
export const Placeholder = () => {
    const styles = useStyleSheet(getStyles);
    return React.createElement(View, { style: styles.container });
};
const getStyles = createStyleSheet(() => ({
    container: {
        flex: 1
    }
}));
//# sourceMappingURL=Placeholder.js.map